import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "VC_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#VC_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M8 0h16v24H8V0z", fill: "#FFDC17" }), /* @__PURE__ */ e.createElement("path", { d: "M24 0h8v24h-8V0z", fill: "#5FBF2B" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0h8v24H0V0z", fill: "#2E42A5" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.726 5.6l-3.04 4.463 3.04 4.304 3.04-4.305-3.04-4.462zm-7.449.079L9 10.063l3.04 4.226 3.04-4.226-2.803-4.384zm.567 9.31l3.277-4.385 2.803 4.385-2.803 4.512-3.277-4.513z",
      fill: "#5FBF2B"
    }
  ))
), a = l;
export {
  a as default
};
